export enum ApplicationFormConfigurationActionType {
  ToggleFormSettingsPopupVisibility = 'applicationFormConfiguration/toggleFormSettingsPopupVisibility',
  SetFormPageToDelete = 'applicationFormConfiguration/setFormPageToDelete',
}
